import { Tooltip as MuiTooltip } from "@mui/material";
import * as React from "react";

export interface TooltipProps {
  children: JSX.Element;
  disableFocusListener?: boolean;
  forceShow?: boolean;
  isOverflowing: boolean;
  placement: "bottom" | "top";
  title?: string | null;
}

const Tooltip: React.FC<TooltipProps> = (props) => {
  const {
    children,
    disableFocusListener,
    forceShow,
    isOverflowing,
    placement,
    title,
  } = props;

  // Always render the tooltip wrapper, but only show the tooltip if overflowing.
  // This avoids focus issues when the tooltip is conditionally rendered.
  const tooltipTitle = isOverflowing && title ? title : "";

  if (forceShow && tooltipTitle) {
    return (
      <MuiTooltip
        disableFocusListener
        disableHoverListener
        disableTouchListener
        // Switching a component from controlled to uncontrolled (or
        // vice-versa) causes an error, so we use the key prop to render
        // distinct MuiTooltips for forceShow={true} and forceShow={false}.
        key={`controlled-${title}`}
        placement={placement}
        open
        title={tooltipTitle}
        // This is to avoid issues with briefly displaying an empty tooltip:
        slotProps={{
          popper: {
            sx: {
              display: isOverflowing || forceShow ? "block" : "none",
            },
          },
        }}
      >
        {children}
      </MuiTooltip>
    );
  }

  return (
    <MuiTooltip
      disableFocusListener={disableFocusListener}
      // Switching a component from controlled to uncontrolled (or
      // vice-versa) causes an error, so we use the key prop to render
      // distinct MuiTooltips for forceShow={true} and forceShow={false}.
      key={`uncontrolled-${title}`}
      placement={placement}
      title={tooltipTitle}
      // This is to avoid issues with briefly displaying an empty tooltip:
      slotProps={{
        popper: {
          sx: {
            display: isOverflowing || forceShow ? "block" : "none",
          },
        },
      }}
    >
      {children}
    </MuiTooltip>
  );
};

export default Tooltip;
